async function login(username) {
  try {
    const res = await window.axios.put('/api/v1/admin/login', { username });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function verify(code, username) {
  try {
    const res = await window.axios.put('/api/v1/admin/verify', { username, code });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function steptwo(password) {
  try {
    const res = await window.axios.put('/api/v1/admin/twostep', { password });
    return res.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { login, verify, steptwo };
